import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/providers/auth-provider";
import { listEnergy } from "@/services/inventory/list-energy";
import { queryKeys } from "./query-keys";

export const useEnergyInventory = () => {
  const { state } = useAuth();

  return useQuery({
    queryKey: queryKeys.inventoryEnergy,
    queryFn: async () => {
      const response = await listEnergy();
      if (!response.ok) throw new Error(response.message);
      return response.data.player_energy;
    },
    enabled: state.status === "authenticated",
  });
};
